var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNote = function SvgNote(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 2.33546C0.666992 1.41335 1.41237 0.666626 2.33367 0.666626H13.667C14.5847 0.666626 15.3337 1.41095 15.3337 2.33212V9.33329C15.3337 9.5101 15.2634 9.67967 15.1384 9.8047L9.80506 15.138C9.68004 15.2631 9.51047 15.3333 9.33366 15.3333H2.33117C1.41542 15.3333 0.666992 14.5851 0.666992 13.6645V2.33546ZM2.33367 1.99996C2.15038 1.99996 2.00033 2.1481 2.00033 2.33546V13.6645C2.00033 13.8508 2.15385 14 2.33117 14H9.05752L14.0003 9.05715V2.33212C14.0003 2.15002 13.851 1.99996 13.667 1.99996H2.33367Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33366 8.66663H14.667C14.9366 8.66663 15.1797 8.82905 15.2829 9.07817C15.3861 9.32729 15.3291 9.61403 15.1384 9.8047L9.80506 15.138C9.6144 15.3287 9.32765 15.3857 9.07854 15.2825C8.82942 15.1794 8.66699 14.9363 8.66699 14.6666V9.33329C8.66699 8.9651 8.96547 8.66663 9.33366 8.66663ZM10.0003 9.99996V13.0571L13.0575 9.99996H10.0003Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/note.c622c1ea.svg";
export { ForwardRef as ReactComponent };